export default __webpack_public_path__ + "static/streamlined-management-min-60b0df2271d2619b0ae184f85d17e2ef.png";